import SystemMessage from "./SystemMessage";

export default class SystemMessageEvent {
    /**
     * @constructor
     * @param {String} type 
     * @param {SystemMessage} systemMessage 
     */
    constructor(type, systemMessage) {
        this.type = type;
        this.systemMessage = systemMessage;
    }
}

SystemMessageEvent.OPEN = "SystemMessageEvent.OPEN";
SystemMessageEvent.DISMISS_ALL = "SystemMessageEvent.DISMISS_ALL";